import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ns-align-items-baseline ${className}`}>
            <button type="submit" className="ns-act-btn ns-text-align-right ns-w-100">
                {text}
            </button>
            <span class="ns__icon__wrapper">
                <svg class="ns__icon ns__icon--angle-right ns-1v72vbw" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                    <path d="M44.329 28c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.786-0.561-1.291 0-0.449 0.224-0.954 0.561-1.291l22.052-22.052-22.052-22.052c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z"></path>
                </svg>
            </span>
        </div>
    )
}